const MigrationSelector = {
  createMigrationOldDBToNewDB: async () => {
    try {
      const jsonSTate = await getDataFromOldDB();
      console.log({ jsonSTate });
      return await writeToNewDB({ fixedState: jsonSTate });
    } catch (error) {
      throw new Error('error', error);
    }
  },
  deleteDB: async () => {
    return new Promise((resolve, reject) => {
      const deleteRequest = indexedDB.deleteDatabase('my-oplii-test');

      deleteRequest.onsuccess = function () {
        resolve('Database deleted successfully');
      };

      deleteRequest.onerror = function () {
        reject('Error deleting database:');
      };

      deleteRequest.onblocked = function () {
        reject('Database deletion blocked — close all tabs using it');
      };
    });
  }
};

export default MigrationSelector;

const getDataFromOldDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('my-oplii-test');

    request.onerror = function () {
      reject(new Error('Failed to open DB'));
    };

    request.onsuccess = function () {
      try {
        const db = request.result;

        const tx = db.transaction('keyvaluepairs', 'readwrite');
        const store = tx.objectStore('keyvaluepairs');
        const getReq = store.get('persist:root');

        getReq.onerror = function () {
          reject(new Error('Failed to fetch data from store'));
        };

        getReq.onsuccess = function () {
          try {
            const value = getReq.result;

            if (!value) {
              return reject(new Error('No data found'));
            }

            let state = JSON.parse(value);

            const keys = Object.keys(state);
            const looksLikeCharObject = keys.every((k) => !isNaN(k));

            if (looksLikeCharObject) {
              let jsonString = '';
              for (let i = 0; i < keys.length; i++) jsonString += state[i];
              state = JSON.parse(jsonString);
            }

            const fixedState = {};
            for (const key in state) {
              const value = state[key];
              try {
                fixedState[key] = typeof value === 'string' ? JSON.parse(value) : value;
              } catch {
                fixedState[key] = value;
              }
            }

            resolve(fixedState);
          } catch (err) {
            reject(err);
          }
          //   writeToNewDB(fixedState);
        };
      } catch (err) {
        reject(err);
      }
    };
  });
};

const writeToNewDB = ({ fixedState }) => {
  return new Promise((resolve, reject) => {
    const newDBName = 'new-my-oplii-test';
    const request = indexedDB.open(newDBName, 1);

    request.onupgradeneeded = function (event) {
      const db = event.target.result;

      // Create the same object store redux-persist uses
      if (!db.objectStoreNames.contains('keyvaluepairs')) {
        db.createObjectStore('keyvaluepairs');
      }
    };

    request.onsuccess = function () {
      const db = request.result;

      const tx = db.transaction('keyvaluepairs', 'readwrite');
      const store = tx.objectStore('keyvaluepairs');
      console.log({ fixedState });
      // MUST stringify the state
      const putReq = store.put(fixedState, 'persist:root');

      putReq.onsuccess = () => {
        console.log('Successfully written to new-my-oplii-test DB');
        resolve('Successfully written to new-my-oplii-test DB');
      };

      putReq.onerror = () => {
        console.error(' Failed to write to new DB:', putReq.error);
        reject('Failed to write to new DB::');
      };
    };

    request.onerror = function () {
      console.error(' Error opening new DB:', request.error);
      reject(' Error opening new DB:');
    };
  });
};

export const isDBExists = (dbName) => {
  return new Promise((resolve) => {
    let existed = true;

    const request = indexedDB.open(dbName);

    request.onupgradeneeded = () => {
      // If this event fires, DB did NOT exist before
      existed = false;
    };

    request.onsuccess = () => {
      request.result.close();

      // If DB didn't exist, delete the newly created empty one
      if (!existed) {
        indexedDB.deleteDatabase(dbName);
      }

      resolve(existed);
    };

    request.onerror = () => {
      resolve(false);
    };
  });
};
